import React from 'react';

const WindowsFrame = ({ children }) => {
  return (
    <div className="windows-frame">
      {/* Top border */}
      <div className="frame-border frame-top"></div>
      
      {/* Left border */}
      <div className="frame-border frame-left"></div>
      
      {/* Right border */}
      <div className="frame-border frame-right"></div>
      
      {/* Bottom border */}
      <div className="frame-border frame-bottom"></div>
      
      {/* Corner decorations */}
      <div className="frame-corner frame-top-left"></div>
      <div className="frame-corner frame-top-right"></div>
      <div className="frame-corner frame-bottom-left"></div>
      <div className="frame-corner frame-bottom-right"></div>
      
      {/* Main content area */}
      <div className="frame-content">
        {children}
      </div>
      
      {/* Windows 7 style shadow */}
      <div className="frame-shadow"></div>
    </div>
  );
};

export default WindowsFrame;
